"use client"

import type React from "react"
import { memo } from "react"
import type { Platform , ConnectorData} from "../../../../types/edit-connector-wizard"

interface AuthenticateStepProps {
  connectorData: ConnectorData
  platforms: Platform[]
  onConnect: (platformId: string, tanentId: number) => void
}

const AuthenticateStep: React.FC<AuthenticateStepProps> = memo(({ connectorData, platforms, onConnect }) => {
  return (
    <div className="authenticate-step">
      <div className="step-header">
        <h1>Connect Your Accounts</h1>
        <p>Authorize access to your Salesforce and HubSpot accounts to keep your data in sync</p>
      </div>

      <div className="platforms-container">
        <div className="platform-card">
          <div className="platform-logo hubspot">
              <img src="https://cdn.worldvectorlogo.com/logos/hubspot-1.svg" alt="HubSpot" />
          </div>
          <h3>HubSpot</h3>
          <div className={`connection-status ${platforms[0]?.connected ? "connected" : "not-connected"}`}>
            <span className="status-dot"></span>
            {platforms[0]?.connected ? "Connected" : "Not Connected"}
          </div>
          <button
            className={`connect-button ${platforms[0]?.connected ? "connected" : ""}`}
            onClick={() => onConnect("hubspot", Number(connectorData.tenant_id))}
            disabled={platforms[0]?.connecting || platforms[0]?.connected}
          >
            {platforms[0]?.connecting ? "Connecting..." : platforms[0]?.connected ? "Connected" : "Connect"}
          </button>
        </div>

        <div className="sync-arrows">
          <div className="direction-arrow bidirectional">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 11l4 4-4 4" />
              <path d="M7 13l-4-4 4-4" />
              <path d="M21 15H3" />
              <path d="M21 9H3" />
            </svg>
          </div>
        </div>

        <div className="platform-card">
          <div className="platform-logo salesforce">
              <img src="https://cdn.worldvectorlogo.com/logos/salesforce-2.svg" alt="Salesforce"  />
          </div>
          <h3>Salesforce</h3>
          <div className={`connection-status ${platforms[1]?.connected ? "connected" : "not-connected"}`}>
            <span className="status-dot"></span>
            {platforms[1]?.connected ? "Connected" : "Not Connected"}
          </div>
          <button
            className={`connect-button ${platforms[1]?.connected ? "connected" : ""}`}
            onClick={() => onConnect("salesforce", Number(connectorData.tenant_id))}
            disabled={platforms[1]?.connecting || platforms[1]?.connected}
          >
            {platforms[1]?.connecting ? "Connecting..." : platforms[1]?.connected ? "Connected" : "Connect"}
          </button>
        </div>
      </div>
    </div>
  )
})

AuthenticateStep.displayName = "AuthenticateStep"

export default AuthenticateStep
